import { PAYEE_PRODUCT_TYPE_TICKET } from "../constants/payeeProducts";
import { QRCODE_END_OF_FILE } from '../constants/qrCodes'

export const getReceiptLink = (receiptId, payeeHandleId="") => {
    return `${window.location.origin}/${payeeHandleId}/r/${receiptId}`
}

export const openReceiptInfo = (receiptId, payeeHandleId = "") => {
    return window.open(getReceiptLink(receiptId, payeeHandleId));
}
export const getTicketReceiptQRCodeData = (lineItemsById={}, payeeId="", receiptId="") => {
    let qrData = ""
    Object.values(lineItemsById).forEach(lineItem => {
        lineItem = {...lineItem, payeeId, receiptId}
        if (lineItem.productType !== PAYEE_PRODUCT_TYPE_TICKET) return ""
        //remove unnecessary fields
        delete lineItem.imageUrl
        delete lineItem.productType
        delete lineItem.quantityInStock
        delete lineItem.hasLimitedStock
        qrData = `${qrData}${JSON.stringify(lineItem)}${QRCODE_END_OF_FILE}`
    })
    return qrData
}